const transactionResponse = (module, response, type) => {
    switch (type) {
        case 'unsubcription':
            return `You have ${response} from these alerts`;
        case 'subcription':
            return `You are now ${response} to these alerts`;
        case 'CPPSNotFound':
            return 'No results match this search try a wider search, selecting `all` under site and/or project';
        case 'dataNotFound':
            return 'No results match this search try a wider search';
        default:
            return `${module} ${response} successfully`};
    }

export default transactionResponse;